angular.module('aprima-bridge').factory('Bridge',
    ['$log', 'IosBridge', 'AndroidBridge', 'WebBridge', 'PrmBridge', 'DeviceSettings',
        function ($log, IosBridge, AndroidBridge, WebBridge, PrmBridge, DeviceSettings) {

            'use strict';

            var getLog = function() {
                return $log.delegate || $log;    
            };

            if (DeviceSettings.isStandaloneBrowser) {
                getLog().info('Using WebBridge for standalone browser');
                return WebBridge;
            }
            else if (DeviceSettings.isIos) {
                getLog().info('Using iOSBridge');
                return IosBridge;
            }
            else if (DeviceSettings.isAndroid) {
                getLog().info('Using AndroidBridge');
                return AndroidBridge;
            }
            else if (DeviceSettings.isPrm) {
                getLog().info('Using PrmBridge');
                return PrmBridge;
            }
            else {
                getLog().info('Using WebBridge');
                return  WebBridge;
            }
        }]);

